import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonService } from 'src/app/provide/common.service';

@Component({
  selector: 'service-card-category',
  templateUrl: './service-card-category.component.html',
  styleUrls: ['./service-card-category.component.scss']
})
export class ServiceCardCategoryComponent implements OnInit {
  @Input() data : any
  @Input() catName : any
  @Input() showDescription : any
  @Output() on_Click = new EventEmitter
  @Output() on_Click_Cat = new EventEmitter
  isLoaded: boolean = false;

  constructor(private commonService:CommonService) { }

  ngOnInit(): void {
  }
  navigateToViewProduct(e){
    this.on_Click.emit(e)
  }
  // navigateTocategory(e,data){
  //   this.on_Click_Cat.emit({
  //     e:e,data:data
  //   })
  // }
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  toFixed(number, toLength: number) {
    return Number(number).toFixed(toLength)
  }
  onImageLoad(){
    this.isLoaded = true
  }
}
